(function () {
  'use strict';

  /*
    TONI PONS — PRODUCT MEDIA
    1) Keep the first product image at its natural aspect ratio.
    2) Add an elegant responsive product-image zoom viewer.
    3) Open zoom from either the image or zoom icon.
    4) Swipe between images while the viewer stays open.
    5) Support click/tap zoom, wheel zoom, pinch zoom and drag/pan.
    6) Load the size-finder core used by the custom product section.
  */

  const MEDIA_STYLE_ID = 'tp-main-product-natural-media';
  const ZOOM_STYLE_ID = 'tp-main-product-zoom-styles';
  const BODY_ZOOM_LOCK = 'tp-product-zoom-open';
  const MODAL_SELECTOR = '[data-tp-zoom-modal]';
  const MIN_SCALE = 1;
  const MAX_SCALE = 4;
  const TAP_ZOOM_SCALE = 2.5;
  const SWIPE_THRESHOLD = 46;

  let activeImages = [];
  let activeIndex = 0;
  let scale = 1;
  let offsetX = 0;
  let offsetY = 0;
  let dragMoved = false;
  let lastTrigger = null;
  let suppressClickUntil = 0;

  const pointers = new Map();
  let gestureMode = 'none';
  let gestureStartX = 0;
  let gestureStartY = 0;
  let gestureStartTime = 0;
  let startOffsetX = 0;
  let startOffsetY = 0;
  let pinchStartDistance = 0;
  let pinchStartScale = 1;
  let pinchStartOffsetX = 0;
  let pinchStartOffsetY = 0;
  let pinchAnchorX = 0;
  let pinchAnchorY = 0;

  function addMediaStyles() {
    if (document.getElementById(MEDIA_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = MEDIA_STYLE_ID;
    style.textContent = `
      .tp-pdp .tp-pdp__media-card.is-first {
        aspect-ratio: auto !important;
        background: transparent !important;
      }

      .tp-pdp .tp-pdp__media-card.is-first .tp-pdp__media-image {
        width: 100% !important;
        height: auto !important;
        max-width: 100% !important;
        display: block !important;
        object-fit: contain !important;
      }

      @media (max-width: 767px) {
        .tp-pdp .tp-pdp__media-card.is-first {
          aspect-ratio: auto !important;
          background: transparent !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function addZoomStyles() {
    if (document.getElementById(ZOOM_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = ZOOM_STYLE_ID;
    style.textContent = `
      .tp-pdp .tp-pdp__media-card.tp-has-zoom {
        position: relative;
      }

      .tp-pdp .tp-pdp__media-card.tp-has-zoom .tp-pdp__media-image {
        cursor: zoom-in;
      }

      .tp-pdp .tp-pdp__zoom-trigger {
        position: absolute;
        top: 14px;
        left: 14px;
        z-index: 8;
        width: 38px;
        height: 38px;
        display: grid;
        place-items: center;
        margin: 0;
        padding: 0;
        border: 1px solid rgba(60, 51, 46, .16);
        border-radius: 50%;
        background: rgba(251, 247, 240, .90);
        color: #3C332E;
        box-shadow: 0 8px 26px rgba(60, 51, 46, .08);
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);
        appearance: none;
        cursor: zoom-in;
        transition: transform .22s ease, color .22s ease, border-color .22s ease, background .22s ease;
      }

      .tp-pdp .tp-pdp__zoom-trigger svg {
        width: 17px;
        height: 17px;
        display: block;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.15;
        stroke-linecap: round;
        stroke-linejoin: round;
        pointer-events: none;
      }

      @media (hover: hover) and (pointer: fine) {
        .tp-pdp .tp-pdp__zoom-trigger:hover {
          color: #B1643F;
          border-color: rgba(177, 100, 63, .46);
          background: rgba(251, 247, 240, .97);
          transform: translateY(-1px);
        }
      }

      .tp-product-zoom[hidden] {
        display: none !important;
      }

      .tp-product-zoom {
        position: fixed;
        inset: 0;
        z-index: 2147482500;
        display: block;
        direction: ltr;
        color: #FBF7F0;
        background: rgba(35, 29, 26, .94);
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        opacity: 1;
        overscroll-behavior: contain;
      }

      .tp-product-zoom__stage {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        padding: 46px 72px 92px;
        touch-action: none;
        user-select: none;
        -webkit-user-select: none;
      }

      .tp-product-zoom__image {
        display: block;
        width: auto;
        height: auto;
        max-width: 92vw;
        max-height: calc(100vh - 138px);
        max-height: calc(100dvh - 138px);
        object-fit: contain;
        transform: translate3d(0, 0, 0) scale(1);
        transform-origin: center center;
        transition: transform .20s ease, opacity .16s ease;
        cursor: zoom-in;
        user-select: none;
        -webkit-user-select: none;
        -webkit-user-drag: none;
        will-change: transform;
      }

      .tp-product-zoom.is-zoomed .tp-product-zoom__image {
        cursor: grab;
        transition: none;
      }

      .tp-product-zoom.is-dragging .tp-product-zoom__image {
        cursor: grabbing;
      }

      .tp-product-zoom__close,
      .tp-product-zoom__nav,
      .tp-product-zoom__zoom-button {
        position: absolute;
        z-index: 5;
        display: grid;
        place-items: center;
        margin: 0;
        padding: 0;
        border: 1px solid rgba(251, 247, 240, .22);
        background: rgba(251, 247, 240, .08);
        color: #FBF7F0;
        appearance: none;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        transition: background .22s ease, border-color .22s ease, transform .22s ease;
      }

      .tp-product-zoom__close {
        top: max(22px, env(safe-area-inset-top));
        right: max(22px, env(safe-area-inset-right));
        width: 42px;
        height: 42px;
        border-radius: 50%;
      }

      .tp-product-zoom__nav {
        top: 50%;
        width: 46px;
        height: 58px;
        transform: translateY(-50%);
      }

      .tp-product-zoom__prev {
        left: max(20px, env(safe-area-inset-left));
      }

      .tp-product-zoom__next {
        right: max(20px, env(safe-area-inset-right));
      }

      .tp-product-zoom__close svg,
      .tp-product-zoom__nav svg,
      .tp-product-zoom__zoom-button svg {
        width: 18px;
        height: 18px;
        display: block;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.15;
        stroke-linecap: round;
        stroke-linejoin: round;
        pointer-events: none;
      }

      .tp-product-zoom__counter {
        position: absolute;
        left: 50%;
        bottom: 72px;
        z-index: 5;
        min-width: 56px;
        transform: translateX(-50%);
        color: rgba(251, 247, 240, .80);
        font-size: 11px;
        font-weight: 300;
        line-height: 1;
        letter-spacing: .08em;
        text-align: center;
        pointer-events: none;
      }

      .tp-product-zoom__controls {
        position: absolute;
        left: 50%;
        bottom: max(18px, env(safe-area-inset-bottom));
        z-index: 6;
        display: grid;
        grid-template-columns: 42px 64px 42px;
        align-items: center;
        min-height: 42px;
        transform: translateX(-50%);
        border: 1px solid rgba(251, 247, 240, .18);
        border-radius: 999px;
        background: rgba(35, 29, 26, .38);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        overflow: hidden;
      }

      .tp-product-zoom__zoom-button {
        position: static;
        width: 42px;
        height: 42px;
        border: 0;
        background: transparent;
      }

      .tp-product-zoom__zoom-level {
        display: grid;
        place-items: center;
        height: 42px;
        color: rgba(251, 247, 240, .90);
        font-size: 11px;
        font-weight: 300;
        letter-spacing: .04em;
        border-left: 1px solid rgba(251, 247, 240, .12);
        border-right: 1px solid rgba(251, 247, 240, .12);
        pointer-events: none;
      }

      @media (hover: hover) and (pointer: fine) {
        .tp-product-zoom__close:hover,
        .tp-product-zoom__nav:hover,
        .tp-product-zoom__zoom-button:hover {
          border-color: rgba(251, 247, 240, .45);
          background: rgba(251, 247, 240, .16);
        }

        .tp-product-zoom__close:hover {
          transform: rotate(4deg);
        }

        .tp-product-zoom__prev:hover {
          transform: translateY(-50%) translateX(-2px);
        }

        .tp-product-zoom__next:hover {
          transform: translateY(-50%) translateX(2px);
        }
      }

      html.${BODY_ZOOM_LOCK},
      body.${BODY_ZOOM_LOCK} {
        overflow: hidden !important;
        overscroll-behavior: none !important;
      }

      @media (max-width: 767px) {
        .tp-pdp .tp-pdp__zoom-trigger {
          top: 10px;
          left: 10px;
          width: 36px;
          height: 36px;
        }

        .tp-product-zoom__stage {
          padding:
            max(54px, calc(env(safe-area-inset-top) + 44px))
            8px
            max(98px, calc(env(safe-area-inset-bottom) + 84px));
        }

        .tp-product-zoom__image {
          max-width: 98vw;
          max-height: calc(100vh - 150px);
          max-height: calc(100dvh - 150px);
        }

        .tp-product-zoom__close {
          top: max(12px, env(safe-area-inset-top));
          right: max(12px, env(safe-area-inset-right));
          width: 40px;
          height: 40px;
        }

        .tp-product-zoom__nav {
          top: 50%;
          width: 40px;
          height: 46px;
          border-radius: 999px;
          transform: translateY(-50%);
          background: rgba(35, 29, 26, .28);
        }

        .tp-product-zoom__prev {
          left: max(8px, env(safe-area-inset-left));
        }

        .tp-product-zoom__next {
          right: max(8px, env(safe-area-inset-right));
        }

        .tp-product-zoom__counter {
          bottom: max(68px, calc(env(safe-area-inset-bottom) + 56px));
        }

        .tp-product-zoom__controls {
          bottom: max(12px, env(safe-area-inset-bottom));
          grid-template-columns: 44px 62px 44px;
        }

        .tp-product-zoom__zoom-button {
          width: 44px;
          height: 44px;
        }

        .tp-product-zoom__zoom-level {
          height: 44px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .tp-pdp .tp-pdp__zoom-trigger,
        .tp-product-zoom__image,
        .tp-product-zoom__close,
        .tp-product-zoom__nav,
        .tp-product-zoom__zoom-button {
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getBestImageSource(image) {
    if (!image) return '';

    const candidates = String(image.getAttribute('srcset') || '')
      .split(',')
      .map(function (item) {
        const parts = item.trim().split(/\s+/);
        const width = parts[1] && parts[1].endsWith('w') ? parseInt(parts[1], 10) : 0;
        return { url: parts[0] || '', width: Number.isFinite(width) ? width : 0 };
      })
      .filter(function (item) { return item.url; })
      .sort(function (a, b) { return b.width - a.width; });

    return candidates.length
      ? candidates[0].url
      : (image.currentSrc || image.src || '');
  }

  function ensureLightbox() {
    let modal = document.querySelector(MODAL_SELECTOR);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'tp-product-zoom';
    modal.hidden = true;
    modal.dataset.tpZoomModal = '';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'عرض الصورة المكبرة');

    modal.innerHTML = `
      <div class="tp-product-zoom__stage" data-tp-zoom-stage>
        <img class="tp-product-zoom__image" data-tp-zoom-image alt="">
      </div>

      <button type="button" class="tp-product-zoom__close" data-tp-zoom-close aria-label="إغلاق">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18"></path>
        </svg>
      </button>

      <button type="button" class="tp-product-zoom__nav tp-product-zoom__prev" data-tp-zoom-prev aria-label="الصورة السابقة">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14.5 5.5L8 12l6.5 6.5"></path>
        </svg>
      </button>

      <button type="button" class="tp-product-zoom__nav tp-product-zoom__next" data-tp-zoom-next aria-label="الصورة التالية">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9.5 5.5L16 12l-6.5 6.5"></path>
        </svg>
      </button>

      <div class="tp-product-zoom__counter" data-tp-zoom-counter aria-live="polite"></div>

      <div class="tp-product-zoom__controls" aria-label="أدوات التكبير">
        <button type="button" class="tp-product-zoom__zoom-button" data-tp-zoom-out aria-label="تصغير الصورة">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 12h10"></path>
          </svg>
        </button>
        <div class="tp-product-zoom__zoom-level" data-tp-zoom-level>100%</div>
        <button type="button" class="tp-product-zoom__zoom-button" data-tp-zoom-in aria-label="تكبير الصورة">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 7v10M7 12h10"></path>
          </svg>
        </button>
      </div>
    `;

    document.body.appendChild(modal);
    bindLightbox(modal);
    return modal;
  }

  function getStageCenter(modal) {
    const stage = modal.querySelector('[data-tp-zoom-stage]');
    if (!stage) return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const rect = stage.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    };
  }

  function updateZoomLevel(modal) {
    const level = modal.querySelector('[data-tp-zoom-level]');
    if (level) level.textContent = Math.round(scale * 100) + '%';
  }

  function resetTransform(modal, animate) {
    scale = 1;
    offsetX = 0;
    offsetY = 0;
    dragMoved = false;
    pointers.clear();
    gestureMode = 'none';

    modal.classList.remove('is-zoomed', 'is-dragging');

    const zoomImage = modal.querySelector('[data-tp-zoom-image]');
    if (!zoomImage) return;

    zoomImage.style.transition = animate ? 'transform .20s ease' : 'none';
    zoomImage.style.transform = 'translate3d(0, 0, 0) scale(1)';
    updateZoomLevel(modal);

    window.setTimeout(function () {
      if (zoomImage) zoomImage.style.transition = '';
    }, 220);
  }

  function clampOffsets(modal) {
    const stage = modal.querySelector('[data-tp-zoom-stage]');
    const image = modal.querySelector('[data-tp-zoom-image]');

    if (!stage || !image || scale <= 1.001) {
      offsetX = 0;
      offsetY = 0;
      return;
    }

    const imageWidth = image.clientWidth * scale;
    const imageHeight = image.clientHeight * scale;
    const maxX = Math.max(0, (imageWidth - stage.clientWidth) / 2);
    const maxY = Math.max(0, (imageHeight - stage.clientHeight) / 2);

    offsetX = Math.max(-maxX, Math.min(maxX, offsetX));
    offsetY = Math.max(-maxY, Math.min(maxY, offsetY));
  }

  function applyTransform(modal, animate) {
    const image = modal.querySelector('[data-tp-zoom-image]');
    if (!image) return;

    clampOffsets(modal);
    modal.classList.toggle('is-zoomed', scale > 1.01);

    image.style.transition = animate ? 'transform .20s ease' : 'none';
    image.style.transform =
      'translate3d(' + offsetX + 'px,' + offsetY + 'px,0) scale(' + scale + ')';

    updateZoomLevel(modal);

    if (animate) {
      window.setTimeout(function () {
        if (image) image.style.transition = '';
      }, 220);
    }
  }

  function setScale(modal, nextScale, animate, clientX, clientY) {
    const previousScale = scale;
    const clamped = Math.max(MIN_SCALE, Math.min(MAX_SCALE, nextScale));

    if (clamped <= 1.01) {
      scale = 1;
      offsetX = 0;
      offsetY = 0;
      applyTransform(modal, animate);
      return;
    }

    if (Number.isFinite(clientX) && Number.isFinite(clientY) && previousScale > 0) {
      const center = getStageCenter(modal);
      const anchorX = clientX - center.x;
      const anchorY = clientY - center.y;
      const ratio = clamped / previousScale;

      offsetX = anchorX - (anchorX - offsetX) * ratio;
      offsetY = anchorY - (anchorY - offsetY) * ratio;
    }

    scale = clamped;
    applyTransform(modal, animate);
  }

  function renderActiveImage(modal) {
    if (!activeImages.length) return;

    if (activeIndex < 0) activeIndex = activeImages.length - 1;
    if (activeIndex >= activeImages.length) activeIndex = 0;

    const sourceImage = activeImages[activeIndex];
    const zoomImage = modal.querySelector('[data-tp-zoom-image]');
    const counter = modal.querySelector('[data-tp-zoom-counter]');
    const prev = modal.querySelector('[data-tp-zoom-prev]');
    const next = modal.querySelector('[data-tp-zoom-next]');

    resetTransform(modal, false);

    if (zoomImage) {
      zoomImage.style.opacity = '.25';
      zoomImage.onload = function () {
        zoomImage.style.opacity = '1';
      };
      zoomImage.src = getBestImageSource(sourceImage);
      zoomImage.alt = sourceImage.alt || '';
      if (zoomImage.complete) zoomImage.style.opacity = '1';
    }

    if (counter) {
      counter.textContent = (activeIndex + 1) + ' / ' + activeImages.length;
    }

    const hasMultiple = activeImages.length > 1;
    if (prev) prev.hidden = !hasMultiple;
    if (next) next.hidden = !hasMultiple;
  }

  function openZoom(section, image, trigger) {
    if (!section || !image) return;

    const modal = ensureLightbox();
    activeImages = Array.from(
      section.querySelectorAll('.tp-pdp__media-card .tp-pdp__media-image')
    );
    activeIndex = Math.max(0, activeImages.indexOf(image));
    lastTrigger = trigger || image;

    renderActiveImage(modal);
    modal.hidden = false;
    document.documentElement.classList.add(BODY_ZOOM_LOCK);
    document.body.classList.add(BODY_ZOOM_LOCK);

    window.requestAnimationFrame(function () {
      const close = modal.querySelector('[data-tp-zoom-close]');
      if (close) close.focus({ preventScroll: true });
    });
  }

  function closeZoom(modal) {
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    resetTransform(modal, false);
    document.documentElement.classList.remove(BODY_ZOOM_LOCK);
    document.body.classList.remove(BODY_ZOOM_LOCK);

    activeImages = [];
    activeIndex = 0;

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      try {
        lastTrigger.focus({ preventScroll: true });
      } catch (error) {
        lastTrigger.focus();
      }
    }
    lastTrigger = null;
  }

  function moveImage(modal, direction) {
    if (activeImages.length < 2) return;
    activeIndex += direction;
    renderActiveImage(modal);
  }

  function pointerDistance(a, b) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function pointerMidpoint(a, b) {
    return {
      x: (a.x + b.x) / 2,
      y: (a.y + b.y) / 2
    };
  }

  function rebaseSinglePointer() {
    const first = pointers.values().next().value;
    if (!first) {
      gestureMode = 'none';
      return;
    }

    gestureStartX = first.x;
    gestureStartY = first.y;
    gestureStartTime = Date.now();
    startOffsetX = offsetX;
    startOffsetY = offsetY;
    gestureMode = scale > 1.01 ? 'pan' : 'swipe';
  }

  function bindLightbox(modal) {
    if (modal.dataset.tpZoomBound === 'true') return;
    modal.dataset.tpZoomBound = 'true';

    const stage = modal.querySelector('[data-tp-zoom-stage]');
    const image = modal.querySelector('[data-tp-zoom-image]');
    const close = modal.querySelector('[data-tp-zoom-close]');
    const prev = modal.querySelector('[data-tp-zoom-prev]');
    const next = modal.querySelector('[data-tp-zoom-next]');
    const zoomIn = modal.querySelector('[data-tp-zoom-in]');
    const zoomOut = modal.querySelector('[data-tp-zoom-out]');

    close.addEventListener('click', function () {
      closeZoom(modal);
    });

    prev.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      moveImage(modal, -1);
    });

    next.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      moveImage(modal, 1);
    });

    zoomIn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setScale(modal, scale + 0.5, true);
    });

    zoomOut.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setScale(modal, scale - 0.5, true);
    });

    image.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (Date.now() < suppressClickUntil || dragMoved) {
        dragMoved = false;
        return;
      }

      if (scale > 1.01) {
        setScale(modal, 1, true);
      } else {
        setScale(modal, TAP_ZOOM_SCALE, true, event.clientX, event.clientY);
      }
    });

    modal.addEventListener('wheel', function (event) {
      if (modal.hidden) return;
      event.preventDefault();

      const step = event.deltaY < 0 ? 0.35 : -0.35;
      setScale(modal, scale + step, false, event.clientX, event.clientY);
    }, { passive: false });

    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY,
        type: event.pointerType
      });

      try {
        stage.setPointerCapture(event.pointerId);
      } catch (error) {}

      dragMoved = false;

      if (pointers.size === 1) {
        gestureStartX = event.clientX;
        gestureStartY = event.clientY;
        gestureStartTime = Date.now();
        startOffsetX = offsetX;
        startOffsetY = offsetY;
        gestureMode = scale > 1.01 ? 'pan' : 'swipe';
      } else if (pointers.size === 2) {
        const values = Array.from(pointers.values());
        const midpoint = pointerMidpoint(values[0], values[1]);
        const center = getStageCenter(modal);

        pinchStartDistance = Math.max(1, pointerDistance(values[0], values[1]));
        pinchStartScale = scale;
        pinchStartOffsetX = offsetX;
        pinchStartOffsetY = offsetY;
        pinchAnchorX = midpoint.x - center.x;
        pinchAnchorY = midpoint.y - center.y;
        gestureMode = 'pinch';
        modal.classList.add('is-dragging');
      }
    });

    stage.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId)) return;

      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY,
        type: event.pointerType
      });

      if (pointers.size >= 2) {
        const values = Array.from(pointers.values()).slice(0, 2);
        const distance = Math.max(1, pointerDistance(values[0], values[1]));
        const nextScale = Math.max(
          MIN_SCALE,
          Math.min(MAX_SCALE, pinchStartScale * (distance / pinchStartDistance))
        );
        const ratio = nextScale / Math.max(.001, pinchStartScale);

        offsetX = pinchAnchorX - (pinchAnchorX - pinchStartOffsetX) * ratio;
        offsetY = pinchAnchorY - (pinchAnchorY - pinchStartOffsetY) * ratio;
        scale = nextScale;
        dragMoved = true;
        applyTransform(modal, false);
        return;
      }

      const dx = event.clientX - gestureStartX;
      const dy = event.clientY - gestureStartY;

      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) dragMoved = true;

      if (gestureMode === 'pan' && scale > 1.01) {
        offsetX = startOffsetX + dx;
        offsetY = startOffsetY + dy;
        modal.classList.add('is-dragging');
        applyTransform(modal, false);
      }
    });

    function endPointer(event) {
      if (!pointers.has(event.pointerId)) return;

      const point = pointers.get(event.pointerId);
      const dx = point.x - gestureStartX;
      const dy = point.y - gestureStartY;
      const elapsed = Date.now() - gestureStartTime;
      const wasSinglePointer = pointers.size === 1;
      const modeAtEnd = gestureMode;

      pointers.delete(event.pointerId);

      try {
        stage.releasePointerCapture(event.pointerId);
      } catch (error) {}

      modal.classList.remove('is-dragging');

      if (modeAtEnd === 'swipe' && wasSinglePointer && scale <= 1.01) {
        const horizontal = Math.abs(dx);
        const vertical = Math.abs(dy);
        const quickEnough = elapsed < 900;

        if (
          horizontal >= SWIPE_THRESHOLD &&
          horizontal > vertical * 1.12 &&
          quickEnough
        ) {
          suppressClickUntil = Date.now() + 450;
          moveImage(modal, dx < 0 ? 1 : -1);
          dragMoved = false;
        }
      }

      if (pointers.size === 1) {
        rebaseSinglePointer();
      } else if (pointers.size === 0) {
        gestureMode = 'none';
      }
    }

    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeZoom(modal);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveImage(modal, -1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveImage(modal, 1);
      } else if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        setScale(modal, scale + 0.5, true);
      } else if (event.key === '-') {
        event.preventDefault();
        setScale(modal, scale - 0.5, true);
      } else if (event.key === '0') {
        event.preventDefault();
        setScale(modal, 1, true);
      }

      if (event.key === 'Tab') {
        const focusable = Array.from(
          modal.querySelectorAll('button:not([hidden]):not([disabled])')
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    function handleViewportChange() {
      if (!modal.hidden && scale > 1.01) applyTransform(modal, false);
    }

    window.addEventListener('resize', handleViewportChange);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
    }
  }

  function createZoomTrigger() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tp-pdp__zoom-trigger';
    button.setAttribute('aria-label', 'تكبير الصورة');
    button.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="10.8" cy="10.8" r="5.8"></circle>
        <path d="M15.2 15.2L20 20"></path>
        <path d="M10.8 8.2v5.2M8.2 10.8h5.2"></path>
      </svg>
    `;
    return button;
  }

  function initZoomSection(section) {
    if (!section || section.dataset.tpZoomReady === 'true') return;

    const cards = Array.from(section.querySelectorAll('.tp-pdp__media-card'));

    cards.forEach(function (card) {
      const image = card.querySelector('.tp-pdp__media-image');
      if (!image) return;

      card.classList.add('tp-has-zoom');

      let trigger = card.querySelector('.tp-pdp__zoom-trigger');
      if (!trigger) {
        trigger = createZoomTrigger();
        card.appendChild(trigger);
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openZoom(section, image, trigger);
      });

      image.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openZoom(section, image, image);
      });
    });

    section.dataset.tpZoomReady = 'true';
  }

  function initZoomAll(root) {
    const scope = root || document;

    addZoomStyles();
    ensureLightbox();

    if (scope.matches && scope.matches('.tp-pdp')) {
      initZoomSection(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('.tp-pdp').forEach(initZoomSection);
    }
  }

  function loadSizeFinderCore() {
    if (document.querySelector('script[data-tp-size-finder-core]')) return;

    let source = '';
    const current = document.currentScript;

    if (current && current.src) {
      source = current.src;
    } else {
      const entry = Array.from(document.scripts).find(function (script) {
        return script.src && script.src.indexOf('tp-main-product-size-finder.js') !== -1;
      });
      if (entry) source = entry.src;
    }

    if (!source) return;

    try {
      const url = new URL(source, window.location.href);
      url.pathname = url.pathname.replace(
        /tp-main-product-size-finder\.js$/,
        'tp-main-product-size-finder-core.js'
      );
      url.search = '';

      const script = document.createElement('script');
      script.src = url.toString();
      script.dataset.tpSizeFinderCore = 'true';
      script.async = false;
      document.head.appendChild(script);
    } catch (error) {
      console.error('Toni Pons size finder could not load.', error);
    }
  }

  function init() {
    addMediaStyles();
    initZoomAll(document);
    loadSizeFinderCore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    addMediaStyles();
    initZoomAll(event.target);
  });
})();
